import { useMemo, useState } from 'react'
import { useMasterData } from '../../../hooks/api/useMasterData'
import { useDispatch, useSelector } from 'react-redux'
import { setTypeModal, setTypeOfShowModalType } from '../../../features/modal/modalSlice'
import { selectedSizeIdFilter, selectedSizeNameFilter, setSelectedSize } from '../../../features/product/productSlice'
import { ArrowDown, ArrowUp } from '../../../assets/icons/Svg'
import ProductTBody from '../../common/tbody/ProductTBody'
import SetupTHead from '../../common/theads/SetupTHead'
import { productTheadData } from '../../../data/admin-data'
import useProductAction from '../../../hooks/actions/useProductAction'

export default function Products() {

    const dispatch = useDispatch()
    const {  getAllProduct, isLoadingGetAllProduct, isErrorGetAllProduct, errorMessageGetAllProduct } = useMasterData()
    const selectedSizeId = useSelector(selectedSizeIdFilter)
    const selectedSizeName = useSelector(selectedSizeNameFilter)
    const [search, setSearch] = useState("");
    const [isShowSize, setIsShowSize] = useState<boolean>(false);
    const { getSizes, isLoadingGetSizes, isErrorGetSizes, errorMessageGetSizes, } = useMasterData()
    const { handleSelectUpdateProduct } = useProductAction()

    const sortedProducts = useMemo(() => {

        const sizeOrder: Record<string, number> = {
            none: 0,
            "8oz": 1,
            "12oz": 2,
            "16oz": 3,
        };

        return (
            getAllProduct
                ?.filter((product) => {
                    // Size filter
                    const matchSize =
                        selectedSizeId === 0 ||
                        product.sizeInfo?.sizeId === selectedSizeId;
                    // Search filter
                    const keyword = search.trim().toLowerCase();

                    const matchSearch =
                        keyword === "" ||
                        product.productName?.toLowerCase().includes(keyword) ||
                        product.categoryInfo?.categoryName
                            ?.toLowerCase()
                            .includes(keyword) ||
                        product.sizeInfo?.size
                            ?.toLowerCase()
                            .includes(keyword);
                    return matchSize && matchSearch;
                })
                .sort((a, b) => {
                    const catA = a.categoryInfo?.categoryName?.toLowerCase() ?? "";
                    const catB = b.categoryInfo?.categoryName?.toLowerCase() ?? "";
                    const catCompare = catA.localeCompare(catB);
                    if (catCompare !== 0) return catCompare;
                    const sizeA = a.sizeInfo?.size?.toLowerCase() ?? "none";
                    const sizeB = b.sizeInfo?.size?.toLowerCase() ?? "none";
                    const orderA =
                        sizeOrder[sizeA] ?? Number.MAX_SAFE_INTEGER;
                    const orderB =
                        sizeOrder[sizeB] ?? Number.MAX_SAFE_INTEGER;
                    return orderA - orderB;
                }) ?? []
        );
    }, [getAllProduct, selectedSizeId, search]);

    return (
        <>
            <div className="flex flex-col gap-2 lg:flex-row lg:items-end lg:justify-between">
                <div className="flex items-end gap-2">
                    <button onClick={() => {
                        dispatch(setTypeModal('newProduct'));
                        dispatch(setTypeOfShowModalType('productModal'));
                    }} className="h-7 rounded bg-blue-600 px-3 text-xs font-medium text-white hover:bg-blue-700">
                        Add New
                    </button>
                    <input
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search products..."
                        className="h-7 w-[280px] rounded border border-gray-300 px-3 text-xs shadow-sm outline-none placeholder:text-gray-400 focus:border-black"
                    />
                </div>
                <div className="relative w-[200px]">
                    <button
                        className="h-7 w-full flex items-center justify-between rounded border border-gray-300 bg-white px-2 text-xs outline-none focus:border-cbColorPrimary"
                        onClick={() => setIsShowSize(!isShowSize)}
                    >
                        <div>{selectedSizeName}</div>
                        <div className="w-3 h-3 flex-shrink-0">
                            {isShowSize ? <ArrowUp /> : <ArrowDown />}
                        </div>
                    </button>
                    {isShowSize && (
                        <ul className="absolute z-10 mt-1 w-full overflow-hidden rounded border border-gray-300 bg-white shadow-lg">
                            {isLoadingGetSizes ? (
                                <li className='px-3 py-1.5 text-xs'>Loading..</li>
                            ) : isErrorGetSizes ? (
                                <li className='px-3 py-1.5 text-xs text-red-500'>{errorMessageGetSizes}</li>
                            ) : (
                                <>
                                    <li
                                        onClick={() => {
                                            setIsShowSize(false);
                                            dispatch(
                                                setSelectedSize({
                                                    id: 0,
                                                    name: "All products",
                                                })
                                            );
                                        }}
                                        className="cursor-pointer px-3 py-1.5 text-xs hover:bg-gray-100"
                                    >
                                        All products
                                    </li>
                                    {getSizes.map((opt) => (
                                        <li
                                            key={opt.sizeId}
                                            onClick={() => {
                                                setIsShowSize(false);
                                                dispatch(
                                                    setSelectedSize({
                                                        id: opt.sizeId,
                                                        name: opt.size,
                                                    })
                                                );
                                            }}
                                            className="cursor-pointer px-3 py-1.5 text-xs hover:bg-gray-100"
                                        >
                                            {opt.size}
                                        </li>
                                    ))}
                                </>
                            )}
                        </ul>
                    )}
                </div>
            </div>
            <div className='h-full overflow-hidden bg-white rounded border'>
                <div className='overflow-y-auto h-full'>
                    <table className='min-w-max w-full'>
                        <SetupTHead data={productTheadData}/>
                        <ProductTBody
                            data={sortedProducts}
                            isLoading={isLoadingGetAllProduct}
                            isError={isErrorGetAllProduct}
                            errorMessage={errorMessageGetAllProduct}
                            isEmpty={sortedProducts.length === 0}
                            handleUpdateProduct={handleSelectUpdateProduct}
                        />
                    </table>
                </div>
            </div>
        </>
    )
}
